import { memo } from 'react'
import GeneralSkeleton from './GeneralSkeleton'
import InputSkeleton from './InputSkeleton'
import Divider from '../Footer/Divider'
import VersionDisplay from '../VersionDisplay'

const SkeletonView = () => (
  <>
    <GeneralSkeleton />
    <Divider />
    <InputSkeleton />
    <Divider />
    <InputSkeleton />
    <Divider />
    <InputSkeleton />
    <Divider />
    <InputSkeleton />
    <Divider />
    <VersionDisplay />
  </>
)

export default memo(SkeletonView)
